export default function authHeader() {
    let user = JSON.parse(localStorage.getItem('token'));
  
    if (user && user.accessToken) {
      return { Authorization: 'Bearer ' + user.accessToken }; // for Spring Boot back-end
    } else {
      return {};
    }
  }
  